/**
 * ============================================================================
 * DizyPro ERP
 * Module : Service CRM
 * Feature: Installed Products
 *
 * File:
 * src/modules/service_crm/installed_products/constants/installedProductValidation.js
 *
 * Description:
 * Centralized validation and default values for Installed Product.
 *
 * Responsibilities:
 * - Default values
 * - Required fields
 * - Field labels
 * - Validation rules
 * - Business rules
 * - Form validation
 * ============================================================================
 */

/* ============================================================================
 * DEFAULT VALUES
 * ========================================================================== */

export const DEFAULT_VALUES = {

    // ===============================================================
    // INVOICE
    // ===============================================================
    invoice_number: "",
    invoice_date: "",
    oa_number: "",

    instance_id: `TEMP_${Math.random().toString(36).substring(2, 8).toUpperCase()}`,
    canopy_number: "",

    // ===============================================================
    // CUSTOMER
    // ===============================================================
    customer_name: "",
    customer_type: "",

    billing_address: "",
    site_address: "",

    country: "INDIA",
    state: "",
    city: "",
    pin_code: "",

    contact_person: "",
    contact_number: "",
    email_id: "",

    // ===============================================================
    // MACHINE
    // ===============================================================
    engine_model_no: "",
    engine_app_code: "",
    engine_serial_no: "",

    emission_norm: "",
    engine_make: "",
    kva_rating: "",
    engine_krm_no: "",

    date_of_installation: "",

    // ===============================================================
    // ALTERNATOR
    // ===============================================================
    alternator_model: "",
    alternator_number: "",

    // ===============================================================
    // PANEL
    // ===============================================================
    panel_type: "",
    panel_serial_no: "",
    panel_make: "",
    phase: "",

    // ===============================================================
    // TECHNICAL
    // ===============================================================
    battery_serial_no: "",
    cooling_type: "",
    running_hours: "",

    tested_by: "",

    // ===============================================================
    // INTERNAL
    // ===============================================================
    service_dealer: "",
    kgd_jakson_executive: "",
    executive_name: "",
    plant_location: "",

    // ===============================================================
    // COMMISSIONING
    // ===============================================================
    commissioning_status: "",
    commissioning_date: "",

    // ===============================================================
    // WARRANTY & AMC
    // ===============================================================
    warranty_start_date: "",
    warranty_end_date: "",
    amc_status: "",

    remarks: ""

};

/* ============================================================================
 * REQUIRED FIELDS
 * ========================================================================== */

export const REQUIRED_FIELDS = [

    // ===============================================================
    // INVOICE
    // ===============================================================
    "invoice_number",
    "invoice_date",
    "oa_number",

    // ===============================================================
    // MACHINE IDENTITY
    // ===============================================================
    "instance_id",
    "canopy_number",

    // ===============================================================
    // CUSTOMER
    // ===============================================================
    "customer_name",
    "customer_type",
    "billing_address",
    "site_address",
    "country",
    "state",
    "city",
    "pin_code",
    "contact_person",
    "contact_number",
    "email_id",

    // ===============================================================
    // ENGINE
    // ===============================================================
    "emission_norm",
    "engine_make",
    "engine_model_no",
    "engine_app_code",
    "engine_serial_no",
    "kva_rating",
    "engine_krm_no",

    // ===============================================================
    // ALTERNATOR
    // ===============================================================
    "alternator_model",
    "alternator_number",

    // ===============================================================
    // PANEL
    // ===============================================================
    "panel_type",
    "panel_serial_no",
    "panel_make",
    "phase",

    // ===============================================================
    // TECHNICAL
    // ===============================================================
    "battery_serial_no",
    "cooling_type",
    "running_hours",
    "tested_by",

    // ===============================================================
    // INTERNAL
    // ===============================================================
    "service_dealer",
    "kgd_jakson_executive",
    "executive_name",
    "plant_location",

    // ===============================================================
    // COMMISSIONING
    // ===============================================================
    "date_of_installation",
    "commissioning_status",
    "commissioning_date",

];

/* ============================================================================
 * FIELD LABELS
 * ========================================================================== */

export const FIELD_LABELS = {

    customer_name: "Customer",

    customer_type: "Customer Type",

    country: "Country",

    state: "State",

    city: "City",

    emission_norm: "Emission Norm",

    engine_make: "Engine Make",

    engine_model_no: "Engine Model",

    kva_rating: "KVA Rating",

    panel_type: "Panel Type",

    panel_make: "Panel Make",

    executive_type: "Executive Type",

    executive_name: "Executive Name",

    commissioning_status: "Commissioning Status",

    date_of_installation: "Date of Installation"

};

/* ============================================================================
 * VALIDATION RULES
 * ========================================================================== */

export const VALIDATION_RULES = {

    serial_number: {

        maxLength: 100

    },

    customer_name: {

        required: true

    },

    customer_type: {

        required: true

    }

};

/* ============================================================================
 * BUSINESS RULES
 * ========================================================================== */

export const BUSINESS_RULES = {

    COUNTRY_STATE_CITY: true,

    ENGINE_DEPENDENCY: true,

    EXECUTIVE_DEPENDENCY: true

};

/* ============================================================================
 * VALIDATION
 * ========================================================================== */

export const validateField = (field, value) => {

    if (REQUIRED_FIELDS.includes(field)) {

        if (
            value === null ||
            value === undefined ||
            value === ""
        ) {

            return `${FIELD_LABELS[field] || field} is required.`;

        }

    }

    return "";

};

export const validateForm = (formData) => {

    const errors = {};

    REQUIRED_FIELDS.forEach(field => {

        // ==========================================================
        // Commissioning Status = NA
        // Date of Installation & Commissioning Date become optional
        // ==========================================================
        if (
            formData.commissioning_status === "NA" &&
            (
                field === "date_of_installation" ||
                field === "commissioning_date"
            )
        ) {
            return;
        }

        const error = validateField(field, formData[field]);

        if (error) {

            errors[field] = error;

        }

    });

    return {

        isValid: Object.keys(errors).length === 0,

        errors

    };

};